module.exports = __webpack_public_path__ + "video-39a03f27dcc1.webm";